<template>
  <nav>
    <playlistStory :story='story'
                   v-for='(story, index) in storyPages'
                   :key='index'
                   class='story'
                   :target='target'
                   :filtered='filtered'/>
  </nav>
</template>

<script>
import mixins from './.././mixins.js';

export default {
  props: ['stories', 'filtered', 'tags', 'target'],
  mixins: [mixins],
  computed: {
    storyPages: function() {
      return this.getPagesFromPaths(this.stories)
    },
    allTags: function() {
      var returnArray = [];
      Object.entries(this.storyPages).map(function(item){
        returnArray = returnArray.concat(item[1].strings.story_tags.split(/,\s*/))
      });
      returnArray = returnArray.filter((item, pos) => returnArray.indexOf(item) === pos);
      returnArray = returnArray.filter(Boolean);
      return returnArray
    }
  },
  mounted: function() {
    this.$emit('update:tags', this.allTags);
  },
  methods: {
    getPagesFromPaths: function(list) {
      let self = this;
      let paths = (typeof list == 'object') ? Object.values(list) : list;
      let pages = {};
      paths.map(function(path){
        let page = self.pageFromURI(path);
        if(page) pages[page.uid] = self.pageFromURI(path);
      });
      //console.log(pages);
      return pages;
    }
  }
}
</script>

<style scoped>

  nav {
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 2rem;
    width: 100%;
  }

</style>
